// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Clients_pageLayout__5MYUc"};